var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-appdev-box"},[_c('div',{staticClass:"mobile-en-title"},[_vm._v(_vm._s("APP development".toUpperCase()))]),_c('div',{staticClass:"mobile-cn-title"},[_vm._v("APP开发")])])
}
var staticRenderFns = []

export { render, staticRenderFns }